<template>
  <div>
    <img
      src="../assets/images/siteImages/403Unauthorize.svg"
      class="img-fluid mx-auto d-block pic my-5"
      sizes=""
    />
  </div>
  <div class="text-center my-2">
    <h4 class="text-danger">
      <svg
        width="36px"
        height="36px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="mx-2"
      >
        <path
          d="m7.775 0a1.8 1.8 0 0 0 -1.273.527l-5.974 5.976a1.8 1.8 0 0 0 -.528 1.272v8.45c0 .478.19.936.528 1.274l5.974 5.974a1.8 1.8 0 0 0 1.273.527h8.45a1.8 1.8 0 0 0 1.273-.527l5.975-5.974a1.8 1.8 0 0 0 .527-1.274v-8.45a1.8 1.8 0 0 0 -.527-1.272l-5.975-5.976a1.8 1.8 0 0 0 -1.273-.527zm4.427 3c1.02 0 .958 1.108.958 1.108v6.784s-.009.218.16.218c.188 0 .175-.226.175-.226l-.002-5.63s-.05-.986.959-.986c1.01 0 .97.983.97.983v7.621s.014.158.141.158.944-2.122.944-2.122.451-1.497 2.576-1.1c.038.008-.167.688-.167.688l-2.283 6.556s-.943 3.648-4.919 3.648c-5.044 0-4.808-5.407-4.814-5.405v-7.733s-.016-.99.897-.99c.858 0 .849.99.849.99l.007 3.583s-.004.172.167.172c.16 0 .141-.172.141-.172l.01-5.926s-.055-1.162.966-1.162c1.04 0 .983 1.142.983 1.142v5.611s-.005.204.152.204c.168 0 .154-.206.154-.206l.01-6.693s-.056-1.115.966-1.115z"
        ></path>
      </svg>
      <span> مراجع گرامی شما به این صفحه/بخش دسترسی ندارید</span>
    </h4>
  </div>
  <div class="text-center my-2">
    <a href="/" class="btn bg-gray-800 btn-sm text-white p-1"
      ><i class="fi fi-home fs-6 me-2"></i
    ></a>
    <a class="btn bg-gray-800 btn-sm text-white p-1" @click="backPage">
      <i class="fi fi-reload fs-6 me-2"></i>
    </a>
  </div>
</template>
<script>
export default {
  components: {},
  methods: {
    backPage() {
      window.history.back();
    },
  },
  mounted() {
    let spiners = document.getElementsByClassName('modal-backdrop fade show');
    if (spiners)
      while (spiners.length != 0) {
        spiners[0].remove();
      }
  },
};
</script>
<style scoped>
.pic {
  height: 50vh;
  width: 70vw;
}
a {
  color: black;
  text-decoration: none;
}
a:hover {
  color: #7b7ce6;
}
</style>
